let chartMap,isMobile;

$(document).ready(() => {
    isMobile = document.body.clientWidth < 1000;

    initMap();
    timeline();
    cpfNav();
    fp();
    su();
    oj();
    swiperBanner();
    new WOW().init()

    // document.body.addEventListener("touchstart", function() {});

})


function initMap() {
    var dom = document.getElementById("chart-map");
    chartMap = echarts.init(dom);
    echarts.registerMap('world', worldGeo);

    const officeData = [
        {"name": "Atlanta, Headquater", "value": [-85.812151, 35.462296]},
        {"name": "UK Office", "value": [-1.356696, 53.028199]},
        {"name": "Shenzhen Office", "value": [114.015525, 22.620736]}
    ];

    const salesData = [
        {"name": "CA 2014.9", "value": [-109.62, 57.80]},
        {"name": "US 2011.5", "value": [-95.46, 42.51]},
        {"name": "MX 2017.8", "value": [-103.96, 24.36]},
        {"name": "BR 2019.11", "value": [-49.20, -11.28]},
        {"name": "UK 2013.7", "value": [-2.39, 53.97]},
        {"name": "FR 2014.8", "value": [2.73, 46.55]},
        {"name": "ES 2014.8", "value": [-3.45, 40.54]},
        {"name": "DE 2014.8", "value": [10.67, 52.49]},
        {"name": "IT 2014.11", "value": [12.52, 42.72]},
        {"name": "PL 2021.3", "value": [9.31, 52.22]},
        {"name": "NL 2020.4", "value": [5.91, 52.48]},
        {"name": "SE 2020.10", "value": [17.34, 64.74]},
        {"name": "AE 2019.6", "value": [54.16, 23.68]},
        {"name": "IN 2018.4", "value": [79.10, 21.33]},
        {"name": "CN 2016.1", "value": [116.41, 39.90]},
        {"name": "SG 2020.4", "value": [103.82, 1.31]},
        {"name": "JP 2017.8", "value": [139.49, 36.00]},
        {"name": "AU 2018.4", "value": [149.03, -35.23]},
    ];

    let f = 1;
    if (isMobile) {
        f = 0.5;
    }
    const countryData = [
        {name: "Canada", value: 1},
        {name: "United States", value: 1},
        {name: "Mexico", value: 1},
        {name: "Brazil", value: 1},
        {name: "United Kingdom", value: 1},
        {name: "France", value: 1},
        {name: "Spain", value: 1},
        {name: "Germany", value: 1},
        {name: "Italy", value: 1},
        {name: "Poland", value: 1},
        {name: "Netherlands", value: 1},
        {name: "Sweden", value: 1},
        {name: "United Arab Emirates", value: 1},
        {name: "India", value: 1},
        {name: "China", value: 1},
        {name: "Singapore", value: 1},
        {name: "Japan", value: 1},
        {name: "Australia", value: 1},
    ];

    let option = {
        backgroundColor: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 1,
            y2: 1,
            colorStops: [
                {
                    offset: 0,
                    color: '#020202', // 0% 处的颜色
                },
                {
                    offset: 1,
                    color: '#020202', // 100% 处的颜色
                },
            ],
            globalCoord: false, // 缺省为 false
        },
        legend: {
            show: !isMobile,
            left: '45%',
            bottom: 0,
            // height: 20,
            itemHeight: 20,
            textStyle: {
                color: '#fff',
                // fontSize: '14px',
            },
            data: ['Our Offices']
        },
        tooltip: {
            trigger: 'item',
            borderColor: '#ff7d01', // 设置边框透明
            backgroundColor: '#ff7d01',
            padding: [5, 10], // 去掉内边距
            extraCssText: 'border-radius: 10px;',
            textStyle: {
                color: '#fff',
                fontSize: 12,
            },
            formatter: function (param) {
                if (param.seriesName === 'Our Offices') {
                    return ` <div class="map-tooltip"> ${param.name} <div>`;
                } else {
                    return ` <div class="map-tooltip font-small"> ${param.name} <div>`;
                }
            },
        },
        geo: {
            map: 'world',
            zoom: 1.2,
            // left: '5%', // 减少左边距
            // right: '5%', // 减少右边距
            // top: '5%', // 减少上边距
            // bottom: '5%', // 减少下边距
            show: true,
            roam: false,
            label: {
                normal: {
                    show: false,
                },
                emphasis: {
                    show: false,
                },
            },
            itemStyle: {
                normal: {
                    areaColor: "#bcbcbc",//'#3a7fd5',
                    borderColor: '#fbfcfd', //线
                    // shadowColor: '#092f8f', //外发光
                    // shadowBlur: 20,
                },
                emphasis: {
                    areaColor: '#ccc', //悬浮区背景
                },
            },
        },
        // 视觉映射组件
        visualMap: {
            show: false,
            min: 0,
            max: 1,
            text: ['max', 'min'],
            realtime: false,
            calculable: true,
            color: ['#ff8814', '#bcbcbc'],
            // color: ['#ff7d01', '#bcbcbc'],
        },
        series: [
            /* {
                 name: 'Global Market',
                 type: 'scatter',
                 coordinateSystem: 'geo',
                 // symbol: 'pin',
                 symbol: 'image://https://cdn.shopify.com/s/files/1/1696/1045/files/supfam-other-marker.png?v=1734423687', // 设置为图片URL
                 symbolSize: [20 * f, 24 * f],
                 symbolOffset: [0, -12 * f], // 偏移量，使标记位于坐标点上方
                 label: {
                     normal: {
                         show: true,
                         offset: [0, -20*f], // 文字标签相对于标记的偏移量，使文字位于图标上方
                         textStyle: {
                             color: '#ffffff',
                             fontSize: 10,
                             fontWeight: 'bold', // 设置文字为粗体
                         },
                         formatter(param) {
                             return param.data.name;
                         },
                     },
                 },
                 data: salesData,
                 showEffectOn: 'render',
                 rippleEffect: {
                     brushType: 'stroke',
                 },
                 hoverAnimation: true,
                 zlevel: 1,
             },*/
            {
                name: "Our Offices",
                type: 'scatter',
                coordinateSystem: 'geo',
                // symbol: 'pin',
                symbol: 'image://https://cdn.shopify.com/s/files/1/1696/1045/files/supfam-office-marker.png?v=1734423687', // 设置为图片URL
                symbolSize: [40 * f, 36 * f],
                symbolOffset: [-12 * f, -20 * f], // 偏移量，使标记位于坐标点上方
                data: officeData,
                showEffectOn: 'render',
                rippleEffect: {
                    brushType: 'stroke',
                },
                hoverAnimation: true,
                zlevel: 1,
            },
            {
                name: "Global Market",
                roam: false,
                type: "map",
                showLegendSymbol: false,
                mapType: 'world',
                zoom: 1.2,
                selectedMode: "false",
                label: {
                    normal: {
                        show: false,
                    },
                    emphasis: {
                        show: false,
                    },
                },
                data: countryData,
                itemStyle: {
                    normal: {
                        areaColor: "#bcbcbc",//'#3a7fd5',
                        borderColor: '#fbfcfd', //线
                        // shadowColor: '#092f8f', //外发光
                        // shadowBlur: 20,
                    },
                    emphasis: {
                        //悬浮区背景
                        // areaColor: '#ccc',
                        // areaColor: '#713e02', //悬浮区背景
                    },
                },
                animation: false,
            },
        ],
    };

    chartMap.setOption(option);

    window.addEventListener("resize", function () {
        chartMap.resize();
    });
}

function timeline() {
    const lis = document.querySelectorAll(".timeline ul li");
    const ojs = document.querySelectorAll(".oj");

    // Initialize the first content and add active class to the first li
    lis[0].classList.add("active");
    document.querySelector(`.oj-${lis[0].getAttribute('data-year')}`).style.display = 'block';

    lis.forEach(li => {
        li.onclick = () => {
            // Remove active class from all lis
            lis.forEach(item => item.classList.remove('active'));
            // Add active class to the clicked li
            li.classList.add('active');

            // Hide all contents
            ojs.forEach(content => content.style.display = 'none');
            // Show the content corresponding to the clicked li
            const contentToShow = document.querySelector(`.oj-${li.getAttribute('data-year')}`);
            if (contentToShow) {
                contentToShow.style.display = 'block';
            }
        }
    });
}

function cpfNav() {
    const lis = document.querySelectorAll(".fp-nav ul li");
    const prods = document.querySelectorAll(".prod");

    // Initialize the first content and add active class to the first li
    lis[0].classList.add("active");
    document.querySelector(`.prod-${lis[0].getAttribute('data-category')}`).style.display = 'block';

    lis.forEach(li => {
        li.onclick = () => {
            // Remove active class from all lis
            lis.forEach(item => item.classList.remove('active'));
            // Add active class to the clicked li
            li.classList.add('active');

            // Hide all contents
            prods.forEach(content => content.style.display = 'none');
            // Show the content corresponding to the clicked li
            const contentToShow = document.querySelector(`.prod-${li.getAttribute('data-category')}`);
            if (contentToShow) {
                contentToShow.style.display = 'block';
            }
        }
    });
}

function fp() {
    const productList = [
        {
            prod: 'apple1',
            stars: '★★★★★',
            content: 'Apple AirPods 4 Unicorn Beetle PRO Rugged Case-Black',
            price: '$32.99',
            link: 'https://supcase.com/collections/airpods/products/apple-airpods-4-unicorn-beetle-pro-rugged-case-black'
        },
        {
            prod: 'apple2',
            stars: '★★★★⯪',
            content: 'iPhone 16 Pro Max 6.9 inch Unicorn Beetle PRO Rugged Case-Black',
            price: '$24.99',
            link: 'https://supcase.com/collections/iphone-16-pro-max-cases/products/iphone-16-pro-max-6-9-inch-unicorn-beetle-pro-rugged-case-black'
        },
        {
            prod: 'apple3',
            stars: '★★★★⯪',
            content: 'iPhone 16 Pro Max 6.9 inch Unicorn Beetle MAG XT MagSafe Case- Black',
            price: '$24.99',
            link: 'https://supcase.com/collections/iphone-16-pro-max-cases/products/iphone-16-pro-max-6-9-inch-unicorn-beetle-mag-xt-magsafe-case-black'
        },
        {
            prod: 'apple4',
            stars: '★★★★⯪',
            content: 'iPad Pro 11 Inch (2024) Unicorn Beetle Pro Rugged Case-Black',
            price: '$32.99',
            link: 'https://supcase.com/collections/ipad-11/products/ipad-pro-11-inch-2024-unicorn-beetle-pro-rugged-case-black'
        },
        {
            prod: 'apple5',
            stars: '★★★★⯪',
            content: 'Apple Watch Ultra Unicorn Beetle PRO Wristband Case with Tempered Glass Screen Protectors (49mm)-Black',
            price: '$19.99',
            link: 'https://supcase.com/products/apple-watch-unicorn-beetle-pro-wristband-case-with-glass-screen-protectors-49mm-black'
        },
        {
            prod: 'samsung1',
            stars: '',
            content: 'Galaxy S25 Ultra Unicorn Beetle MAG XT Bumper Case -Dark Green',
            price: '$26.99',
            link: 'https://supcase.com/products/galaxy-s25-ultra-unicorn-beetle-mag-xt-bumper-case-dark-green'
        },
        {
            prod: 'samsung2',
            stars: '',
            content: 'Galaxy S25 Ultra Unicorn Beetle PRO Rugged Case-Black',
            price: '$26.99',
            link: 'https://supcase.com/products/galaxy-s25-ultra-unicorn-beetle-pro-rugged-case-black'
        },
        {
            prod: 'samsung3',
            stars: '',
            content: 'Galaxy S25 Ultra UB Grip MagSafe Phone Case-Black',
            price: '$25.99',
            link: 'https://supcase.com/products/galaxy-s25-ultra-ub-grip-magsafe-phone-case-black'
        },
        {
            prod: 'switch1',
            stars: '★★★★☆',
            content: 'Nintendo Switch OLED Unicorn Beetle PRO Dockable Grip Case-Clear',
            price: '$17.99',
            link: 'https://supcase.com/products/nintendo-switch-oled-unicorn-beetle-pro-dockable-grip-case-clear'
        },
        {
            prod: 'switch2',
            stars: '★★★★☆',
            content: 'Nintendo Switch OLED Unicorn Beetle PRO Dockable Grip Case-Metallic Blue',
            price: '$21.99',
            link: 'https://supcase.com/products/nintendo-switch-oled-unicorn-beetle-pro-dockable-grip-case-metallic-blue'
        },
        {
            prod: 'switch3',
            stars: '★★★★☆',
            content: 'Nintendo Switch OLED Unicorn Beetle PRO Dockable Grip Case-Dark Green',
            price: '$21.99',
            link: 'https://supcase.com/products/nintendo-switch-oled-unicorn-beetle-pro-dockable-grip-case-dark-green'
        },
        {
            prod: 'switch4',
            stars: '★★★★☆',
            content: 'Nintendo Switch OLED Unicorn Beetle PRO Dockable Grip Case-Metallic Red',
            price: '$21.95',
            link: 'https://supcase.com/products/nintendo-switch-oled-unicorn-beetle-pro-dockable-grip-case-metallic-red'
        },
    ];
    productList.forEach(p => {
        $(".hotspot." + p.prod)
            .attr("href", "javascript:void(0)")
            .append(
                `<a href="${p.link}" class="tooltip"> 
    <div class="stars">${p.stars}</div> 
    <p>${p.content}</p> 
    <div class="price">${p.price}</div> 
</a>`);
    })
}

function su() {
    $(".su-card-quiz .link").hover(
        stayTuned,
        function () {
            $(this).text('Find Your Match')
        }
    );
    $(".su-card-custom .link").hover(
        stayTuned,
        function () {
            $(this).text('Start Designing')
        }
    );
    $(".su-card-quiz .link").click(stayTuned);
    $(".su-card-custom .link").click(stayTuned);

    function stayTuned() {
        $(this).text('Stay Tuned');
    }

}

function oj(){
    if(!isMobile) {
        return;
    }
    let ojSwiper = new Swiper('#our-journey .swiper', {
        loop: true,
        autoplay: true,
        pagination: {
            el: '.swiper-pagination',
        },
        // navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        // },
        // scrollbar: {
        //     el: '.swiper-scrollbar',
        // },
    });
}

function swiperBanner(){

    let bannerSwiper = new Swiper('.banner-swiper .swiper', {
        loop: true,
        autoplay: true,
        pagination: {
            el: '.banner-swiper .swiper-pagination',
        },
        // navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        // },
        // scrollbar: {
        //     el: '.swiper-scrollbar',
        // },
    });

}
